import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { RootState } from "../../../store/store";
import { SessionStatus } from "../../../types/session.definition";

export const Logo: React.FC<{ white?: boolean }> = ({ white = false }) => {
  const navigate = useNavigate();
  const { sessionStatus } = useSelector((state: RootState) => state.session);
  const { session } = useSelector((state: RootState) => state.session);

  const handleLogoClick = () => {
    // If user is logged in, redirect to their role-specific home page
    if (sessionStatus === SessionStatus.VALID_SESSION && session?.user) {
      const role = session.user.roleName?.toLowerCase();

      switch (role) {
        case "patient":
          navigate("/profile");
          break;
        case "doctor":
          navigate("/doctor/profile");
          break;
        case "manager":
          navigate("/manager/profile");
          break;
        default:
          navigate("/");
          break;
      }
    } else {
      // Not logged in, go to home page
      navigate("/");
    }
  };

  return (
    <div
      className="flex items-center"
      onClick={handleLogoClick}
      style={{ cursor: "pointer" }}
    >
      <img
        src={white ? "/image/logo1.png" : "/image/logo.png"}
        alt="MEDECINE360"
        className="h-16 w-32"
      />
    </div>
  );
};
